import React, { useState } from 'react'
import { useQuery } from 'react-query'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Input, FormGroup, Label } from 'reactstrap'
import filterInProgressDocuments from '../../../api/filterInProgressDocuments'
import filterValidatedDocuments from '../../../api/filterValidatedDocuments'
import getResearchKeys from '../../../api/getResearchKeys'
import ResearchedDocumentModal from './ResearchedDocumentModal'
import Loader from '../../utilities/loader';

const ResearchKeyDropdown = ({ documentsStatus }) => {
    const [data, setData] = useState();
    const [documents, setDocuments] = useState(null);
    const [showResearch, setShowResearch] = useState(false);
    const selectedProject = useSelector(state => state.selectedProject);
    const { form_name } = useParams();
    const { isLoading, data: researchKeys, refetch } = useQuery("getResearchKeys" + selectedProject.name + form_name, () => getResearchKeys(selectedProject?.name, form_name))

    const updateData = (key, value) => setData(prev => ({ ...prev, [key]: value }))
    const handleSubmit = async (e) => {
        e.preventDefault();
        let res
        if (documentsStatus === "VALIDATED") {
            res = await filterValidatedDocuments(selectedProject.name, form_name, data);
        }
        if (documentsStatus === "inProgress") {
            res = await filterInProgressDocuments(selectedProject.name, form_name, data);
        }
        setDocuments(res?.data);
        setShowResearch(true);
    }

    if (isLoading) return <><Loader /></>;

    return (
        <>
            <ResearchedDocumentModal showResearch={showResearch} documentsStatus={documentsStatus} documents={documents} handleCloseResearch={() => setShowResearch(false)} />
            <form onSubmit={handleSubmit}>
                <FormGroup className="flex items-center m-0 gap-1">
                    {/* <Label className="m-0 whitespace-nowrap" for="exampleSelect">Key name: </Label> */}
                    <Input onChange={(e) => updateData("research_key", e.target.value)} type="select" name="select" id="exampleSelect">
                        <option disabled selected value>Choose a key</option>
                        {researchKeys?.data?.data.map((val) => <option value={val} key={val}>{val}</option>)}
                    </Input>
                    <Input onChange={(e) => updateData("filter_value", e.target.value)} placeholder="Enter value" type="text" className="w-32" />
                </FormGroup>
            </form>

        </>
    )
}

export default ResearchKeyDropdown
